import { makeVar } from '@apollo/client'

export const currentSrpUrl = makeVar('')
